import { render, staticRenderFns } from "./ItemImageContainer.vue?vue&type=template&id=8413e390&"
import script from "./ItemImageContainer.vue?vue&type=script&lang=ts&"
export * from "./ItemImageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ItemImageContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports